jQuery(document).ready(function(){
	jQuery('#nav-icon3').click(function(){
                jQuery(this).toggleClass('open');
                jQuery('#menumobile').slideToggle();
    });
    jQuery('.current_page_ancestor').find('.submenu-toggle').click();
});